/* RESPONSIBLE TEAM: team-inbox */

/**
 * Characters that are visually similar to GSM-7 characters but are encoded
 * as UCS-2, causing SMS messages to use ~2.3x more segments than necessary.
 *
 * Common sources: AI-generated text (Fin), macOS auto-correct, rich text editors.
 */
const GSM_REPLACEMENTS: Record<string, string> = {
  '\u2018': "'", // left single quotation mark
  '\u2019': "'", // right single quotation mark (smart apostrophe)
  '\u201C': '"', // left double quotation mark
  '\u201D': '"', // right double quotation mark
  '\u2014': '-', // em dash
  '\u2013': '-', // en dash
  '\u2026': '...', // horizontal ellipsis
  '\u00A0': ' ', // non-breaking space
};

const REPLACEMENT_PATTERN = new RegExp(Object.keys(GSM_REPLACEMENTS).join('|'), 'g');

/**
 * Replaces common non-GSM-7 characters with their GSM-7 equivalents.
 * Used to calculate accurate SMS segment counts without modifying displayed text.
 */
export default function normalizeForGsm7(text: string): string {
  if (!text) {
    return text;
  }
  return text.replace(REPLACEMENT_PATTERN, (match) => GSM_REPLACEMENTS[match]);
}
